/**
 * The shortcut-chip vocabulary and the rule for when a chip is already applied.
 *
 * Kept out of the component file so it can be unit-tested: this project's
 * tsconfig emits `jsx: preserve`, which Jest cannot execute, so anything
 * importable from a `.tsx` is untestable.
 */

export const CHIPS = [
  { id: 'rapide', labelKey: 'recipes.shortcuts.quick', icon: 'clock' as const },
  { id: 'frigo', labelKey: 'recipes.shortcuts.pantry', icon: 'box' as const },
  { id: 'note', labelKey: 'recipes.shortcuts.topRated', icon: 'star' as const },
  { id: 'surprise', labelKey: 'recipes.shortcuts.surprise', icon: 'shuffle' as const },
  { id: 'veg', labelKey: 'recipes.shortcuts.vegetarian', icon: null, dotColor: '#5d7c43' },
] as const;

export type ShortcutChipId = typeof CHIPS[number]['id'];

/**
 * True when a filter equivalent to this chip is already applied.
 *
 * Matching is by token family rather than exact id: the "≤ 20 min" chip counts
 * as applied whenever *any* time filter is set, because time is single-valued —
 * offering it again would suggest you can stack two.
 */
export function isChipActive(chipId: string, activeTokenIds: string[]): boolean {
  return activeTokenIds.some((id) => {
    if (chipId === 'rapide') return id.startsWith('time_');
    if (chipId === 'note') return id.startsWith('rate_');
    if (chipId === 'surprise') return id.startsWith('sort_');
    if (chipId === 'veg') return id.startsWith('diet_veg');
    if (chipId === 'frigo') return id === 'pantry_match';
    return id === chipId;
  });
}

/** The chips still worth offering, given what is already applied. */
export function availableChips(activeTokenIds: string[]) {
  return CHIPS.filter((chip) => !isChipActive(chip.id, activeTokenIds));
}
